import React, { Component } from 'react';
import ReactDataGrid from 'react-data-grid';
import { mapFilter, mapSorter } from './sortFilter';
import debounce from 'debounce';
import Spinner from '../components/Spinner/Spinner';
import MobileGrid from '../components/MobileGrid/MobileGrid';
import { Toolbar } from 'react-data-grid-addons';
import classNames from 'classnames';
import withWindowDimensions from '../hoc/withWindowDimensions';
import config from '../config';
import './DataGrid.scss';
import apiHelper from '../api/apiHelper';
import { produce } from 'immer';
import Papa from 'papaparse';

class DataGrid extends Component {
  constructor(props) {
    super(props);
    const me = this;

    me.state = {
      dataRows: [],
      //totalRows: [],
      totalColumns: [],
      changed: false,
      filters: [],
      sorters: null,
      headerFiltersHeight: 45,
      filteredColumns: [],
    };

    this.toolbarRef = null;
    this.filterComponents = [];
    this.setDataGridRef = (element) => {
      const { gridRef } = this.props;
      if (gridRef && typeof gridRef === 'function') {
        gridRef(element);
      }

      //const tbar = this.toolbarRef;
      this.dataGridRefs = element;
    };
  }

  componentDidMount() {
    // if(this.props.showFilter){
    // this
    //     .dataGridRefs
    //     .current
    //     .onToggleFilter();
    // }
    const me = this;
    me.setState({ dataRows: me.props.dataRows }, () => {
      me._getTotalRowColumns().then(() => {});
    });
    if (this.dataGridRefs && !this.props.hideToolbar) {
      this.dataGridRefs.onToggleFilter();
    }
    // const gridRef = this.dataGridRefs;
    // gridRef.current.setState({headerFiltersHeight:this.headerFiltersHeight});
  }

  componentDidUpdate(prevProps) {
    const me = this;
    if (prevProps) {
      if (prevProps.changed !== me.props.changed) {
        me._changeState();
      }
    }
  }

  _changeState() {
    const me = this;
    me.setState({ totalColumns: [] }, () => {
      me.setState({ totalColumns: me.columns }, () => {});
    });
  }

  async _getTotalRowColumns() {
    const me = this;
    me.columns = me.props.columns.map((f) => ({
      key: f.key,
      name: f.name,
      width: f.width,
      resizable: f.resizable,
      changed: f.changed,
      formatter: me._totalFormatter.bind(me, f.key, f.isCurrencyColumn),
      //formatter: f.isCurrencyColumn ? f.formatter: me._totalFormatter.bind(me, f.key)
    }));
    me.setState({ totalColumns: me.columns });
  }

  _totalFormatter(column, isCurrency, data) {
    let row = data.row;
    let value = isCurrency ? `$${row[column]}` : row[column];
    let context = <label>{value}</label>;
    //let context = <label>{row[column]}</label>;
    return context;
  }

  handleSortChange = (sortColumn, sortDirection) => {
    var sortCondition = mapSorter(sortColumn, sortDirection);
    //this.props.onSortChange(sortCondition);
    this.setState(
      {
        sorters: sortCondition,
      },
      () => this.props.onQueryChange(this._prepareQuery(), this.sorters, this.filters),
    );
  };

  _generateFilters = (columnFilters) => {
    let filters = this.state.filters;
    const previosFilteredColumns = columnFilters.map((f) => f.property);
    //remove previous filters for this column
    filters = filters.filter((f) => !previosFilteredColumns.includes(f.property));
    const filtersToAdd = columnFilters.filter((f) => f.action !== 'REMOVE_FILTER' && f.value !== '');
    if (filtersToAdd) {
      filters = filters.concat(filtersToAdd);
    }
    return filters;
  };

  _prepareQuery = () => {
    return apiHelper.buildSortFilterParams(this.state.sorters, this.state.filters);
  };

  forceRefreshGrid = () => {
    const grid = this.dataGridRefs;
    if (!grid) return; //mobile view no need to refresh
    const offset = grid.state.scrollOffset;
    grid.setState({ scrollOffset: 1 }, () => {
      grid.setState({ scrollOffset: offset });
    });
  };

  storeColumnFilter = (columnFilterInfo) => {
    let index = this.state.filteredColumns.findIndex((f) => f.property === columnFilterInfo.property);
    if (index !== -1) {
      this.setState(
        produce((draft) => {
          draft.filteredColumns[index] = columnFilterInfo;
        }),
      );
    } else {
      this.setState(
        produce((draft) => {
          draft.filteredColumns.push(columnFilterInfo);
        }),
      );
    }
  };

  exportToCsv = () => {
    let exportData = this.props.data;
    if (typeof this.props.exportMap === 'function') {
      exportData = this.props.exportMap(exportData);
    }

    const csv = Papa.unparse(exportData);

    // Create and download file
    const blob = new Blob(['\ufeff' + csv], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.setAttribute('href', url);
    link.setAttribute('download', 'AccountHistory.csv');
    link.style.display = 'none';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  clearFilters = () => {
    this.resetFilterComponents();
    this.setState({ filters: [] }, () =>
      this.props.onQueryChange(this._prepareQuery(), this.state.sorters, this.state.filters),
    );
  };

  handleFilterChange = debounce((filter) => {
    let filters = null;
    if (filter.column && filter.column.filterMapper) {
      filters = filter.column.filterMapper(filter);
    } else {
      filters = mapFilter(filter);
    }
    if (Array.isArray(filters) && filters.length > 0 && !filters.isSingleLineFilter) {
      let filterInfo = {
        property: filters[0].property,
        option: filters.length,
      };
      this.storeColumnFilter(filterInfo);
    } else {
      let filterInfo = { property: filters.property, option: 1 };
      this.storeColumnFilter(filterInfo);
    }

    //const gridRef = this.dataGridRefs;
    const allFilters = this._generateFilters(filters);

    let filtersHeight = 45;
    if (this.state.filteredColumns.findIndex((f) => f.option > 1) !== -1) {
      filtersHeight = 85;
    }

    this.setState({ headerFiltersHeight: filtersHeight }, () => {
      this.forceRefreshGrid();
    });

    this.setState(
      {
        filters: allFilters,
        //changed: !this.state.changed
      },
      () => {
        this.props.onQueryChange(this._prepareQuery(), this.sorters, this.filters);
      },
    );
  }, 1000);

  _totalRowRenderer = ({ renderBaseRow, ...props }) => {
    return <div>{renderBaseRow(props)}</div>;
  };

  _mobileTotalRow = () => {
    const me = this;
    const { totalRows } = this.props;
    const columns = me.props.columns.filter((c) => !c.noTotal).map((c) => ({ ...c, editable: false }));

    columns[0].name = 'Totals';

    return totalRows !== undefined && totalRows.length > 0 ? (
      <React.Fragment>
        <div className="mobile-total-grid">
          <MobileGrid
            changed={this.state.changed}
            id="TotalGridMobile"
            columns={columns}
            totalRows={me.props.totalRows}
            rowGetter={(rowNumber) => {
              const row = totalRows[rowNumber];
              return row;
            }}
            style={{ height: 'auto !important' }}
            rowsCount={totalRows !== undefined ? totalRows.length : 0}
            onClearFilters={this.clearFilters}
          />
        </div>
      </React.Fragment>
    ) : null;
  };

  saveFilterRef = (element) => {
    if (element === null) return;
    this.filterComponents.push(element);
  };

  resetFilterComponents = () => {
    this.filterComponents.forEach((c) => {
      if (c.resetComponentState) {
        c.resetComponentState();
      }
      //       if( c instanceof MultiSelectFilter){

      // c.setState({rawValue: [], changed:new Date()})
      // c.forceUpdate();
      //       }
    });
  };
  render() {
    const me = this;
    const spinner = me.props.loading ? <Spinner /> : null;

    let totalsRows = me.props.totalRows;
    let rowGetterTotals = (rowNumber) => totalsRows[rowNumber];

    let toolbar = me.props.hideToolbar ? null : (
      <Toolbar ref={(element) => (this.toolbarRef = element)} enableFilter={false}>
        <button className="btn" onClick={this.clearFilters} disabled={me.state.filters && me.state.filters.length <= 0}>
          Reset Filters
        </button>

        <button className="btn" onClick={this.exportToCsv}>
          Export To CSV
        </button>
      </Toolbar>
    );
    const mobileTotalGrid = this._mobileTotalRow();

    //this.filterComponents = [];
    const columns = this.props.columns.map((c) => {
      const Tag = c.filterRenderer ? c.filterRenderer : null;
      const Comp = (props) => <Tag {...props} ref={this.saveFilterRef} />;
      return {
        ...c,
        filterRenderer: Tag ? Comp : null,
      };
    });

    return (
      <React.Fragment>
        {this.props.dimensions.width &&
        this.props.dimensions.width < config.MobileViewBreakpoint &&
        this.props.mobileLayoutOnResize ? (
          <React.Fragment>
            <MobileGrid
              {...this.props}
              filters={me.state.filters}
              onAddFilter={me.handleFilterChange}
              onGridSort={me.handleSortChange}
              onClearFilters={this.clearFilters}
            />
            {mobileTotalGrid}
          </React.Fragment>
        ) : (
          <React.Fragment>
            <div className="data-grid">
              <ReactDataGrid
                ref={me.setDataGridRef}
                {...me.props}
                columns={columns}
                headerFiltersHeight={this.state.headerFiltersHeight}
                //headerRowHeight={45}
                toolbar={toolbar}
                onGridRowsUpdated={me.props.onGridRowsUpdated}
                onAddFilter={me.handleFilterChange}
                onGridSort={me.handleSortChange}
              />
            </div>
            {spinner}
            {totalsRows !== undefined && totalsRows.length > 0 ? (
              <div
                className={classNames('total-grid-wrapper', {
                  noHeaderWrapper: this.showHeader,
                })}
              >
                <ReactDataGrid
                  className="TotalGrid"
                  id="TotalGrid"
                  columns={me.state.totalColumns}
                  rowGetter={rowGetterTotals}
                  rowsCount={totalsRows !== undefined ? totalsRows.length : 0}
                  rowRenderer={me._totalRowRenderer}
                  enableCellSelect={true}
                  minHeight={70}
                />
              </div>
            ) : (
              <div />
            )}
          </React.Fragment>
        )}
      </React.Fragment>
    );
  }
}

export default withWindowDimensions(DataGrid);
